module.exports = __webpack_public_path__ + "static/img/href.9a140c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn/href.png
// module id = 7ako
// module chunks = 1